import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  public currentYear: number = 2025;

  public ngOnInit(): void {
    this.currentYear = (new Date()).getFullYear();
  }
}
